module.exports = __webpack_public_path__ + "img/event9.b345cb7f.png";